<template>
    <div class="button-wrapper">
        <button class="button"
			:class="applyClasses"
			:tabindex="isTabbable"
			:aria-label="ariaLabel"
			@click="emitClick"
            :disabled="disabled">
            <div class="button--animated-icon" ref="buttonIcon" v-if="animated">
                <BaseIcon :icon="icon" size="lg" />
            </div>
            <span class="button--title" ref="buttonText">
                <slot></slot>{{title}}
            </span>
        </button>
    </div>
</template>

<script>
	import buttonAnimationMixin from '@/components/mixins/buttonAnimationMixin';
	import { uniq } from 'lodash';

    export default {
        mixins: [buttonAnimationMixin],
        props: {
            title: {
                type: String
			},
			type: {
				type: String,
				default: 'default',
			},
			// TODO refactor button types!
            bigBtn: {
                type: Boolean
            },
            midBtn: {
                type: Boolean
            },
            threeFourths: {
                type: Boolean
            },
            disabled: {
                type: Boolean, 
                default: false
            },
            classNames: {
                type: Array
            },
            icon: {
                type: String,
                default: "cartIcon",
			},
			ariaLabel: {
				type: String,
				defualt: '',
			},
		},
		computed: {
			isTabbable() {
				if (this.ariaLabel !== '') {
					return '0';
				}
				return '-1';
			},
			applyClasses() {
				// TODO refactor button types!
				let classNames = this.classNames || [];
				const bigBtn = this.bigBtn;
				const midBtn = this.midBtn;
				const threeFourths = this.threeFourths;
				const disabled = this.disabled;
				// Apply classes based on type
				const type = this.type || '';
				classNames.push(type);
				switch (type) {
					case 'button-icon-right':
					case 'full-width':
					case 'scaleable-8':
					case 'scaleable-5':
						classNames.push('medium');
						classNames.push('store-button-color');
						break;
					case 'modal-button':
						classNames.push('button--modifier');
						classNames.push('store-button-color');
						classNames.push('side-margin');
					default:
						break;
				};
				if (bigBtn) {
					let names = 'custom big-btn is-size-6 button--modifier';
					names = names.split(' ');
					classNames.push(...names);
				}
				if (midBtn) {
					let names = 'custom mid-btn is-size-6 button--modifier';
					names = names.split(' ');
					classNames.push(...names);
				}
				if (threeFourths) {
					let names = 'custom three-fourths-width button--modifier';
					names = names.split(' ');
					classNames.push(...names);
				}
				if (disabled) {
					let names = 'is-hovered button--modifier disabled';
					names = names.split(' ');
					classNames.push(...names);
				}
				classNames = uniq(classNames);
				return classNames.join(' ');
			}
		},
        methods: {
            emitClick(event) {
                const vue = this;
                if (this.animated) {
                    this.animate(() => {
                        vue.$emit("afterAnimation");
                    });
                }
                this.$emit("click", event);
            },
		},
    }
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.button {
		&:focus {
			border-color: $focusHighlight;
			outline: $focusHighlight auto 4px;
			box-shadow: $focusHighlight 0 0 3px;
		}
	}
	.using-mouse {
		.button {
			&:focus {
				border-color: $storeButtonColor;
				background-color: $storeButtonColor;
				outline: unset;
				&:not(:active) {
					box-shadow: none;
				}
			}
			&.standard-with-icon {
				&:focus {
					border-color: $greyOutline;
					background-color: white;
					color: $defaultTextColor;
				}
			}
		}
		.button--choice-action {
			&:focus {
				background-color: white;
			}
		}
	}

	.button--choice-action {
		&:focus {
			color: $storeButtonColor;
		}
	}
    .button--modifier {
        border-radius: $buttonRadius;
        border-color: transparent;
        
        min-width: 180px;
        height: 36px;
        
        background-color: $storeButtonColor;
        color: $storeButtonTitleColor;

        font-size: 12pt;
		&.inline-7 {
			min-width: 7em;
		}
        &:focus {
			color: $storeButtonTitleColor;
            box-shadow: unset;
        }
        &:hover {
            background-color: $storeButtonColorHover;
            color: $storeButtonTitleColorHover;
            border-color: transparent;
		}
		&.standard-with-icon {
			&:hover {
				border-color: grey;
				background-color: lightgrey;
				color: $defaultTextColor;
			}
		}

        &.addToCart {
			border-radius: $buttonRadius;
			padding: 0 1em;

			min-width: 100%;
			max-width: 50vw;
			height: 3rem;

            color: $storeButtonTitleColor;
            background-color: $storeButtonColor;
            
            font-weight: bold;
        }

		&.choice {
			border-radius: $buttonRadius;
			margin: 0 0.5rem;

			min-width: 6rem;

			background-color: #f4f4f4;
			color: $storeButtonColor;

			&.offer {
				border: 1px solid $offerTextColor;
				margin-left: 1rem;

				min-width: 9rem;

				color: $offerTextColor;
				background-color: $storeButtonOfferColorBackground;
			}
			
			.selected {
				.button {
					color: $storeButtonColor;
					border-color: $storeButtonColor;
				}
				.button--modifier {
					background-color: $storeButtonColor;
					color: $storeButtonTitleColor;
					&.standard-with-icon {
						border-color: grey;
						background-color: $landingPageBackground;
						color: $defaultTextColor;
					}
				}
			}
		}

        &.disabled {
            border-color: transparent;
            
            background-color: $greySeparator;
            cursor: not-allowed;
        }
    }

    .button--animated-icon {
        position: absolute;
        top: 2.6rem;
        
        opacity: 0;
    }

    .button--modifier.custom {
        font-weight: bold;
        height: 60px;
        margin-top: 1em;
    }

    .button--modifier.custom.big-btn {
        width: 100%;
    }

    .custom.mid-btn {
        width: 50%;
    }
    .store-button-color {
        background-color: $storeButtonColor;
        color: $storeButtonTitleColor;
    }

    .square-btn {
		padding: 0.5em 2em;
		border: 2px solid $storeButtonColor;
		border-radius: $buttonRadius;
		height: 2.5em;

        background: $storeButtonColor;
        color: $storeButtonTitleColor;

		font-size: 18px;
        font-weight: bold;
    }

    .square-btn:hover {
        background-color: $storeButtonColor;
        color: $storeButtonTitleColor;
    }

    .square-btn div {
        display: inline-block;
    }

    .store-primary-button-color {
        background-color: $storePrimaryButtonColor;
		color: $storeButtonTitleColor;

		font-weight: 500;
    }

    .store-primary-button-color:hover {
		border: none;

        background-color: $darkerGreenButtonHover;
		color: $storeButtonTitleColorHover;
    }

    .user-button {
        background-color: #5c6c7c;
        color: $storeButtonTitleColor;
    }

    .user-button:hover {
        background-color: $userButtonBackgroundColorHover;
        color: $storeButtonTitleColorHover;
    }
    .user-button:focus {
		border: 1px solid $userButtonBackgroundColorFocus;

		background-color: $userButtonBackgroundColorFocus;
		color: $storeButtonTitleColor;
	}

	.input-field-button {
		border-radius: $buttonRadius;

		min-width: 120px;
		height: 40px;
	}

	.medium {
		font-weight: 600;
		height: 2.8em;
	}

	.button-icon-right {
		padding-right: 2.5em;
	}
	
	        
	.menu-img-order-btn {
		left: 1%;
		position: absolute;
		bottom: 0.1em;
		font-weight: bold;
		min-width: 100px;
	}

	.scaleable-8 {
		height: 8vh;
		width: 100%;
	}

	.scaleable-5 {
		height: 5vh;
		width: 100%;
	}

	// TODO needs a design guide
	.scaleable-fixed-square {
		height: 2.7em;
		width: 100%;
		border-radius: $buttonRadius;
		font-weight: bold;
	}

	.standard-with-icon {
		background-color: $landingPageBackground;
		color: unset;
		border: 1px lightgrey solid;
		text-indent: 2em;
	}
	
	.payment-btn {
        background-color: $checkoutButtonColor;
        border-color: transparent;

        color: $storeButtonTitleColor;
		font-size: 14px;
		font-weight: bold;
		margin-top: 10px;
		padding-left: 1.8em;
		padding-right: 1.8em;
    }

    // TODO Have concrete button types
	@include mobile {
		.button {
			.button--title {
				font-size: 1rem;
				width: 100%;
			}
			&.button--choice-action {
				min-width: 42px;
				margin: 0 0.2rem;

				.button--title {
					font-size: 0.9rem;
				}
			}
			&.scaleable-8 {
				.button--title {
					font-size: 3vh;
					width: 100%;
				}
			}
			&.standard-with-icon {
				.button--title {
					font-size: 0.9em;
				}
			}
			&.side-margin {
				margin: 0 2em;
			}
			&.psuedo-disabled {
				background-color: $storeButtonDisabled;
				color: $storeButtonTitleColor
			}
		}
		.button--modifier {
			&.button--login {
				min-width: 8.5rem;
				height: 46px;
			}
			&.choice {
				&.offer {
					min-width: 6rem;
				}
			}
		}
		.upsell-container {
			.button--modifier {
				margin-top: 0;
			}
		}
		.recent-order-btn {
			.button-wrapper {
				text-align: center;

				.button--modifier {
					min-width: auto;
					max-width: 100%;
				}
				.button--title {
					font-size: 1.1rem;
				}
			}
		}
		.input-field-button {
			min-width: 60px;
			&.fill {
				width: 100%;
				height: 100%;
			}
		}
		.menu-img-order-btn {
			padding: 0em 0.6em;
			height: 26px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseButton.vue